import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import {
  Row,
  Wrapper,
  Logos,
  FooterIconLink,
  FooterIconImg,
  LegalLink,
  Copyright,
  FooterLinkWrap,
  CookieLink,
  FooterNavLink,
} from "./index.styled";

/** House / EHO icon on Legal only — other footer links (e.g. FAQ) use plain nav styling. */
const isLegalFooterLink = (item) => {
  const raw = item.url || "";
  const path = raw
    .replace(/^https?:\/\/[^/]+/i, "")
    .split("?")[0]
    .toLowerCase();
  const normalized = (path.replace(/\/+$/, "") || "/").toLowerCase();
  const isLegalPath =
    normalized === "/legal" || normalized.endsWith("/legal");
  const text = (item.text || "").trim().toLowerCase();
  return isLegalPath || text === "legal";
};

const CopyrightAndLegal = ({ onClick }) => {
  const data = useStaticQuery(graphql`
    query CopyrightAndLegalQuery {
      footerContent {
        content {
          copyright
          footer_icons {
            name
            iconUrl
            iconAlt
            link
            target
          }
          footer_links {
            text
            url
            target
          }
        }
      }
    }
  `);

  const content = data?.footerContent?.content?.[0] || {};
  const copyright = content.copyright ?? "";
  const footerIcons = content.footer_icons ?? [];
  const footerLinks = content.footer_links ?? [];

  return (
    <Wrapper>
      <Row>
        <Logos>
          {footerIcons.map((icon, i) =>
            icon.iconUrl ? (
              <FooterIconLink
                key={i}
                href={icon.link || "#"}
                target={icon.target || "_blank"}
                rel="noopener noreferrer"
                aria-label={icon.name}
              >
                <FooterIconImg src={icon.iconUrl} alt={icon.iconAlt || icon.name} />
              </FooterIconLink>
            ) : null
          )}
        </Logos>
      </Row>
      <Row>
        <Copyright dangerouslySetInnerHTML={{ __html: copyright.replace(/\\n/g, '<br />').replace(/\n/g, '<br />') }} />
        <FooterLinkWrap>
          {footerLinks.map((item, i) =>
            item.text === "Manage Cookie Preferences" ? (
              <CookieLink key={i} className="cmp-revoke-consent">
                {item.text}
              </CookieLink>
            ) : isLegalFooterLink(item) ? (
              <LegalLink
                key={i}
                to={item.url || "#"}
                onClick={onClick}
              >
                {item.text}
              </LegalLink>
            ) : (
              <FooterNavLink
                key={i}
                to={item.url || "#"}
                onClick={onClick}
              >
                {item.text}
              </FooterNavLink>
            )
          )}
        </FooterLinkWrap>
      </Row>
    </Wrapper>
  );
};

export default CopyrightAndLegal;
